export type NodeKey = 'source' | 'spike' | 'finalized' | 'edit' | 'gate' | 'output';

export type NodeState =
  | { kind: 'idle' }
  | { kind: 'active'; label?: string }
  | { kind: 'flash' }
  | { kind: 'done' };

export interface Upload {
  platform: 'youtube' | 'tiktok' | string;
  url: string;
  title: string;
  createdAt: number;
}

export interface ReviewPayload {
  clipId: string;
  clipUrl?: string;
  title: string;
  description: string;
}

export interface Workflow {
  id: string;
  streamerUrl: string;
  streamerHandle?: string;
  tracking: boolean;
  autoUpload: boolean;
  editPrompt: string;
  states: Record<NodeKey, NodeState>;
  uploads: Upload[];
  pendingReview: ReviewPayload | null;
  createdAt: number;
}

export interface Toast {
  id: string;
  workflowId?: string;
  message: string;
  createdAt: number;
}

export const NODE_ORDER: NodeKey[] = ['source', 'spike', 'finalized', 'edit', 'gate', 'output'];

export const NODE_TITLES: Record<NodeKey, string> = {
  source: 'Source & Tracking',
  spike: 'Chat Spike',
  finalized: 'Clip Finalized',
  edit: 'AI Editing',
  gate: 'Review & Upload',
  output: 'Output'
};
